module.exports = __webpack_public_path__ + "img/tick.f879fa5e.svg";